import lessRequire from '../../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

lessRequire('modules/statistics/components/column-control/form/radio-condition-field.less');

const RadioConditionField = props => {
	const className = ['radio-condition-control', [props.className]].join(' ');
	return (
		<div className={className}>
			<input
				type="radio"
				{...props.input}
				id={props.input.name + props.defaultValue}
				checked={props.defaultValue == props.input.value}
				disabled={props.shouldDisabled}
				onChange={() => {
					props.input.onChange(props.defaultValue);
					props.onHideCondition();
				}}
			/>
			<label htmlFor={props.input.name + props.defaultValue} />
		</div>
	);
};

RadioConditionField.propTypes = {
	input: PropTypes.object,
	defaultValue: PropTypes.string,
	shouldDisabled: PropTypes.bool,
	onHideCondition: PropTypes.func,
	className: PropTypes.string
};

export default RadioConditionField;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/column-control/form/radio-condition-field.js